import React, { useState } from "react"
import { Eye, EyeOff } from "lucide-react"
import { cn } from "@/lib/utils"
import { inputClass } from "@/lib/styleClasses"

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    placeholder?: string
}

export const PasswordInput = ({ className, ...props }: PasswordInputProps) => {
    const [show, setShow] = useState(false)
    return (
        <div className="relative">
            <input
                type={show ? "text" : "password"}
                className={cn(inputClass, "pr-10", className)}
                {...props}
            />
            <button
                type="button"
                onClick={() => setShow((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
            >
                {show ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
            </button>
        </div>
    )
}
